@if (!onlyAutopay) {
  <form-control
    [config]="saveMethodConfig"
    [control]="form.get(saveMethodConfig.prop)"
    [attr.data-test-id]="saveMethodControl"
  >
  </form-control>
}

@if (saveMethodValue || onlyAutopay) {
  <form-control
    [config]="autopayConfig"
    [control]="form.get(autopayConfig.prop)"
    [attr.data-test-id]="autopayControl"
  >
  </form-control>
}
